import { useEffect } from 'react';
import { useLoadDataRequest } from '@futrli/shared-services';
import { fetchSceneData } from '../../api/sxp';

type RequestReturnType = Awaited<ReturnType<typeof fetchSceneData>>;

export const useSceneData = (displayGlobalNav: boolean, config: typeof window.__sbc_config) => {
  const { data, load, reset } = useLoadDataRequest<RequestReturnType>();

  // Load new data if displayGlobalNav = true
  useEffect(() => {
    if (displayGlobalNav && config) {
      load(fetchSceneData());
    } else {
      reset();
    }
  }, [config, displayGlobalNav, load, reset]);

  return data;
};
